module.exports = __webpack_public_path__ + "static/media/1028464.73cd5d1c.jpg";